import './styles/simonsLayout.css';
import LoadLinkData from "./LoadLinkData";

export default function NavigateSite() {
    return (<div id="navAlpha" className="sidebox">
            <LoadLinkData formedName={"/data/sitedata.json"}/>
        </div>
    );
}
